import axios from 'axios'

// API base URL for Defang backend
const API_BASE = 'https://aayushpawar11-web--8000.prod1.defang.dev'

// Create axios instance
const API = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Automatically attach token
API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API
